import SearchIcon from "components/icons/SearchIcon";
import React from "react";

interface SearchInputProps {
  searchValue: string;
  setSearchValue: (value: string) => void;
}

export const SearchPoolInput: React.FC<SearchInputProps> = ({
  searchValue,
  setSearchValue,
}) => {
  return (
    <div className="relative">
      <input
        type="text"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        className={`w-[293px] rounded-8 font-Inter bg-blue-light-10 dark:bg-blue-darkMode-30 focus:bg-blue-light-20 hover:bg-blue-light-20 placeholder:text-black-25 dark:placeholder:text-white-25 py-2
                    pl-[40px] pr-4 text-sm
                    outline-none transition-colors placeholder:font-[300]`}
        placeholder="Search by token, PoolID"
      />
      <div
        style={{
          zIndex: 5,
          top: "50%",
          transform: "translateY(-50%)",
          position: "absolute",
          left: "13px",
        }}
      >
        <SearchIcon width={18} height={18} />
      </div>
    </div>
  );
};
